import React from 'react';


const RegularMessage = ({ message }) => {
  const className = `message ${message.isMine ? 'message--mine' : ''}`;

  return (
    <li className={className}>
      <div>
        {message.isSeen && (
          <span className="message-read-indicator">Seen</span>
        )}
        <p>{message.message}</p>
        <span className="message-time">{message.displayTime}</span>
      </div>
    </li>
  );
};

export default RegularMessage;
